<template>
  <div class="slack-callback-container">
    <div class="callback-card">
      <div v-if="loading" class="callback-loading">
        <i class="el-icon-loading"></i>
        <div class="mt-16 fs-18">Connecting to Slack...</div>
        <div class="mt-8 fs-14 fc-6B6B6B">Please wait while we complete the setup</div>
      </div>

      <div v-else-if="error" class="callback-error">
        <i class="el-icon-circle-close error-icon"></i>
        <div class="mt-16 fs-18 fw-600">Connection Failed</div>
        <div class="mt-8 fs-14 fc-6B6B6B">{{ error }}</div>
        <el-button type="primary" class="mt-24" @click="goToIntegrations">
          Back to Integrations
        </el-button>
      </div>

      <div v-else class="callback-success">
        <i class="el-icon-circle-check success-icon"></i>
        <div class="mt-16 fs-18 fw-600">Slack Connected!</div>
        <div class="mt-8 fs-14 fc-6B6B6B">Your Slack workspace has been connected to Happily</div>
        <el-button type="primary" class="mt-24" @click="goToIntegrations">
          Configure Settings
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlackOAuthCallback',

  data() {
    return {
      loading: true,
      error: null,
      success: false
    }
  },

  async mounted() {
    await this.handleCallback()
  },

  methods: {
    async handleCallback() {
      const code = this.$route.query.code
      const errorParam = this.$route.query.error

      if (errorParam) {
        this.loading = false
        this.error = this.$route.query.error_description || 'Slack authorization was cancelled'
        return
      }

      if (!code) {
        this.loading = false
        this.error = 'No authorization code received from Slack'
        return
      }

      try {
        await this.$store.dispatch('slack/handleOAuthCallback', code)
        this.loading = false
        this.success = true

        // Auto-redirect after success
        setTimeout(() => {
          this.goToIntegrations()
        }, 2000)
      } catch (err) {
        this.loading = false
        this.error = err.message || 'Failed to complete Slack connection'
      }
    },

    goToIntegrations() {
      this.$router.push({ name: 'integrations', params: { tab: 'slack' } })
    }
  }
}
</script>

<style lang="scss" scoped>
.slack-callback-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f7fa;
}

.callback-card {
  background: #fff;
  border-radius: 12px;
  padding: 48px 64px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  min-width: 400px;
}

.callback-loading {
  .el-icon-loading {
    font-size: 48px;
    color: #6C30CC;
  }
}

.callback-error {
  .error-icon {
    font-size: 48px;
    color: #F56C6C;
  }
}

.callback-success {
  .success-icon {
    font-size: 48px;
    color: #3AC47D;
  }
}

.fc-6B6B6B {
  color: #6B6B6B;
}
</style>
